/* eslint-disable */
<template lang="html">
  <div style="margin-bottom: 300px">
    <div
      class="display-1 
                d-flex 
                justify-center 
                text-center
                mt-12
                pt-4
                grey--text 
                text--darken-2
                "
      v-text="name"
    ></div>
    <v-container class="my-5">
      <v-layout row>
        <v-card
          class="mx-auto 
                  mb-4
                  mt-2"
          max-width="344"
          v-for="(product, index) in products"
          :key="index"
        >
          <v-img v-bind:src="product.prodImgUrl" height="200px"></v-img>

          <v-card-title style="word-break: normal;" class="text-center">
            <span style="margin: 0 auto" v-text="product.prodName"> </span>
          </v-card-title>
        </v-card>
        <!-- ssss -->
      </v-layout>
    </v-container>
  </div>
</template>
<script>
export default {
  data: () => ({
    name: "SASH Status-ის ზეთები ",
    text: "This is product",
    show: false,
    alignmentsAvailable: ["start", "center", "end", "baseline", "stretch"],
    alignment: "center",
    dense: false,
    justifyAvailable: [
      "start",
      "center",
      "end",
      "space-around",
      "space-between"
    ],
    justify: "center",
    products: [
      {
        prodName: "STATUS VL 3000 SAE 10W40, 200ლ",
        specification: "API: SL/CF-4, ACEA A3/B3/B4 (Semi - Synthetic)",
        prodImgUrl:
          "https://cdn5.vectorstock.com/i/1000x1000/82/89/eps-10-gold-olive-or-engine-oil-splash-3d-vector-24398289.jpg"
      },
      {
        prodName: "STATUS XP SAE 10W-40, 200ლ",
        specification:
          "API: SL/CF-4, ACEA A3/B3/B4, VW 501.01/505.00, MB 229.1, FIAT 9.55535-G2 (Semi - Synthetic)",
        prodImgUrl:
          "https://i2.wp.com/www.lubricantes-sash.com/wp-content/uploads/2017/12/STATUS_XP_10W40.jpg?zoom=1.25&w=930&ssl=1"
      },
      {
        prodName: "STATUS CAR SAE 5W-30, 200ლ, 4ლ",
        specification:
          "ACEA A3/B3/B4, API: SN,SM,SL,SJ/CF, GM-LL B-025, VW 502,00/505.00, BMW LL-01, Renault RN 0700/0710, MB 229.5, Porsche C30, Peugeot & Citroën B712296.",
        prodImgUrl:
          "https://i1.wp.com/www.lubricantes-sash.com/wp-content/uploads/2017/12/STATUS_CAR_5W30.jpg?zoom=1.25&w=930&ssl=1"
      },
      {
        prodName: "STATUS CAR SAE 5W-40, 4ლ, 1ლ",
        specification:
          "ACEA A3/B3/B4, API: SN, SM, SL, SJ/CF, GM-LL B-025, MB 229.5, VW 502,00/505.00, BMW LL-01, Renault RN 0700/0710, Peugeot & Citroën B712296, Porsche A40.",
        prodImgUrl:
          "https://i0.wp.com/www.lubricantes-sash.com/wp-content/uploads/2017/12/STATUS_CAR_5W40_5L.jpg?zoom=1.25&w=930&ssl=1"
      }
    ]
  })
};
</script>
